import { createSelector } from '@reduxjs/toolkit';

const getEvent = (state, props) => {
  const array = state.actorsList.list;
  return array.find((b) => b.id === props.id);
};

export const makeGetEvent = createSelector([getEvent], (event) => event);
